module.exports = __webpack_public_path__ + "static/media/19ESCAP35.02da3b3f.jpg";